import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthGuard } from '@/components/common';
import { 
  EmployeeDashboard, 
  UserManagement, 
  ListingModeration, 
  EmployeeFinancialReports 
} from '@/pages/admin';

/**
 * Employee-specific routes component that handles all admin/employee routes
 * All routes are protected with employee group authentication
 */
export const EmployeeRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Main employee dashboard */}
      <Route 
        path="/dashboard" 
        element={
          <AuthGuard requiredUserGroup="employees">
            <EmployeeDashboard />
          </AuthGuard>
        } 
      />
      
      {/* User management */}
      <Route 
        path="/users" 
        element={
          <AuthGuard requiredUserGroup="employees">
            <UserManagement />
          </AuthGuard>
        } 
      />
      
      {/* Listing moderation */}
      <Route 
        path="/listings" 
        element={
          <AuthGuard requiredUserGroup="employees">
            <ListingModeration />
          </AuthGuard>
        } 
      />
      
      {/* Financial reports */}
      <Route 
        path="/financial" 
        element={
          <AuthGuard requiredUserGroup="employees">
            <EmployeeFinancialReports />
          </AuthGuard>
        } 
      />
      
      {/* Additional employee routes - redirect to dashboard for now */}
      <Route 
        path="/reports" 
        element={
          <AuthGuard requiredUserGroup="employees">
            <EmployeeDashboard />
          </AuthGuard>
        } 
      />
      
      <Route 
        path="/moderation" 
        element={
          <AuthGuard requiredUserGroup="employees">
            <EmployeeDashboard />
          </AuthGuard>
        } 
      />
      
      {/* Default redirect to dashboard */}
      <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
    </Routes>
  );
};